import React, { useEffect, useState } from 'react';
import useParam from '../../../context/ParamContext';
import { AutoCompleteSelectUI, FormErrorUI, FormLabelUI, InputUI } from '../../Interface';
import { Field, useFormikContext } from 'formik';
import { getProjectOrderNumberName } from '../../../utils/getProjectOrderNumberName';
import DynamicPropertyField from '../../DynamicProperty/DynamicPropertyField';
import useConfig from '../../../context/ConfigContext';
import useProjectFields from '../../../hooks/useProjectFields';

const ProjectAddDialogFields = ({ autoCompleteOptions, dynProps, autocompleteData }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();
  const { params } = useParam();
  const { config, getConfig } = useConfig();

  useEffect(() => {
    if (!Object.keys(config).length) getConfig();
  }, []);

  const { projectTypeStatus } = useProjectFields({
    values,
    setFieldValue,
    autocompleteData,
    config,
  });

  const dynPropsParam = params.WORKSHEET_SHOW_DYN_PROPS_BY_PROPERTYID
    ? JSON.parse(params.WORKSHEET_SHOW_DYN_PROPS_BY_PROPERTYID)
    : [];

  return (
    <div className="grid grid-cols-6 gap-x-4 gap-y-3 lg:mx-4 mb-5 mt-2">
      <div className="lg:col-span-2 col-span-6">
        <Field
          type="text"
          name="projectName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectName} />}
          InputLabelProps={{ shrink: values.projectName !== '' }}
        />
      </div>
      <div className="col-span-6 lg:col-span-2">
        <Field
          type="text"
          name="orderNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text={getProjectOrderNumberName(params)} />}
          variant="standard"
          helperText={<FormErrorUI message={errors.orderNumber} />}
          InputLabelProps={{ shrink: values.orderNumber !== '' }}
          disabled={config?.generateProjWorkingNumber}
        />
      </div>
      <div className="col-span-6 lg:col-span-2">
        <Field
          type="autocomplete"
          name="projectTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('projectTypeId', newVal?.value ?? null).then(() => {
              validateField('projectTypeId');
            });
            setFieldValue('projectTypeStatusId', null);
          }}
          InputLabelProps={{ shrink: values.projectTypeId !== '' }}
          selectedValue={values.projectTypeId}
          dataset={autoCompleteOptions.projectType}
        />
      </div>
      {params.PROJECT_SHOW_PROJECT_TYPE_STATUS === 'Y' && (
        <div className="col-span-6 lg:col-span-2">
          <Field
            type="autocomplete"
            name="projectTypeStatusId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Típus státusz" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.projectTypeStatusId} />}
            onChange={(_e, newVal) => {
              setFieldValue('projectTypeStatusId', newVal?.value ?? null).then(() => {
                validateField('projectTypeStatusId');
              });
            }}
            InputLabelProps={{ shrink: values.projectTypeStatusId !== '' }}
            selectedValue={projectTypeStatus.length > 0 && values.projectTypeStatusId}
            selectedLabelValue={
              projectTypeStatus.length > 0
                ? projectTypeStatus.find((cc) => cc.value === values.projectTypeStatusId)?.label
                : ''
            }
            dataset={projectTypeStatus}
          />
        </div>
      )}
      {params.PROJECT_COMPANY_LOCATION_FIELD === 'Y' && (
        <div className="col-span-6 lg:col-span-2">
          <Field
            type="autocomplete"
            name="companyLocationId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Telephely" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.companyLocationId} />}
            onChange={(_e, newVal) => {
              setFieldValue('companyLocationId', newVal?.value ?? null).then(() => {
                validateField('companyLocationId');
              });
            }}
            InputLabelProps={{ shrink: values.companyLocationId !== '' }}
            selectedValue={values.companyLocationId}
            dataset={autoCompleteOptions.companyLocation}
          />
        </div>
      )}
      {dynPropsParam.length > 0 &&
        dynProps
          ?.filter((dynProp) => dynPropsParam.includes(dynProp.propertyId))
          ?.map((dynProp) => (
            <div className="col-span-6 lg:col-span-2">
              <DynamicPropertyField
                fieldData={dynProp}
                name={`dynamicFields.din_${dynProp.property.id}`}
                selectedValues={{}}
                showLabel={true}
              />
            </div>
          ))}
    </div>
  );
};

export default ProjectAddDialogFields;
